import React from "react";
import { Modal } from "react-bootstrap";

type Props = {
  show: boolean;
  onClose: () => void;
  isSkillsTab: boolean;
};

export function SkillEnforceWarningModal({ show, onClose, isSkillsTab }: Props) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>One Skill Enforce</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isSkillsTab ? "Make sure only one skill is enabled before turning on this option." :
        "Make sure only one skill is enabled in the Skill tab before turning on this option."}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary" onClick={onClose}>
          OK
        </button>
      </Modal.Footer>
    </Modal>
  );
}
